import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStopwatch = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "#5200bb",
	viewBox: "0 4 24 20",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3,14a9,9,0,1,0,9-9A9.01,9.01,0,0,0,3,14Zm9-7a7,7,0,1,1-7,7A7.008,7.008,0,0,1,12,7Zm-1,7V9.2a1,1,0,0,1,2,0V13h3a1,1,0,0,1,0,2H12A1,1,0,0,1,11,14Z" })
});
export default SvgStopwatch;
